import { render, staticRenderFns } from "./CramStudentUpload.vue?vue&type=template&id=35e9ac62&"
import script from "./CramStudentUpload.vue?vue&type=script&lang=ts&"
export * from "./CramStudentUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports